export default __webpack_public_path__ + "static/media/styledCom_logo.3eea9cb9.png";